import React from "react";
import PropTypes from 'prop-types';
import AnimateOnScroll from '../components/AnimateOnScroll';
import Bullet from '../components/Bullet';
import { useLanguage } from '../providers/LanguageProvider';

const IntroEasy = ({ id }) => {
  const { translations } = useLanguage();
  
  return (
  <section id={id} className="bg-cream py-16 md:py-24">
    <div className="mx-auto px-6">
      <div className="text-center">
        <AnimateOnScroll>
          <h3 className="text-xl md:text-3xl font-bold text-mocha">{translations.intro.title}</h3>
        </AnimateOnScroll>
        <AnimateOnScroll delay={200}>
          <ul className="mt-10 space-y-3 text-lg">
            {translations.intro.points.map((point, index) => (
              <li key={index}><Bullet />{point}</li>
            ))}

          </ul>
        </AnimateOnScroll>
        <AnimateOnScroll delay={400}>
          <p className="mt-6 text-lg leading-8">{translations.intro.description1}</p>
        </AnimateOnScroll>
        <AnimateOnScroll delay={600}>
          <p className="mt-3 text-lg leading-8">{translations.intro.description2}</p>
        </AnimateOnScroll>
        <AnimateOnScroll delay={800}>
          <p className="mt-10 text-lg md:text-xl font-extrabold">{translations.intro.closing1}</p>
          <p className="mt-2 text-lg md:text-xl font-extrabold">{translations.intro.closing2}</p>
        </AnimateOnScroll>
      </div>
    </div>
  </section>
  );
};

IntroEasy.propTypes = {
  id: PropTypes.string,
};

export default IntroEasy;